import { base64toGuid, getIndexByID, getObjectByID } from "../../api/helpers"
import { ALERT_TYPES } from "./AlertLogger"
import { calcSpeed, getSpeedIn, getSpeedInMs } from "./Settings"


const GEOSTATE_NONE = 0
const GEOSTATE_ZONE_ENTER = 1
const GEOSTATE_ZONE_LEAVE = 2
const GEOSTATE_SPEED_OUT = 3
const GEOSTATE_SPEED_OK = 4


const GEOSTATES = {
    NONE: GEOSTATE_NONE,
    ZONE_ENTER: GEOSTATE_ZONE_LEAVE,
    ZONE_LEAVE: GEOSTATE_ZONE_LEAVE,
    SPEED_OUT: GEOSTATE_SPEED_OUT,
    SPEED_OK: GEOSTATE_SPEED_OK
} 


export class GeofenceLocator{


    constructor(onAction, t){

        //this.networks = networks
        this.onAction = onAction
        this.t = t

        this.geofences = []
        this.geostates = []

    }

    setGeofences(geofences){

        this.geofences = geofences

    }

    newGeostate(){

        return {
            entryState:'',
            speedState:'',
            deviceName:'',
            dt:''
        }
            
    }



    process(point, deviceID){

        if(point.Speed==undefined) point.Speed = Math.random()*100


        //console.log(point)
        //alert('process GPS point '+point)

        if(point.ID!==null){
            deviceID = point.ID
        }

        if(point.Latitude){
            point.lat = point.Latitude
        }

        if(point.Longitude){
            point.lng = point.Longitude
        }

        //console.log('process point')
        //console.log(point)
        //alert('process '+point.lat + ', '  +point.lng+ '; deviceID='+point.ID  )


        this.geofences.forEach(geofence => {

            if(geofence.ON==false) return

            let paths =  this.getPaths(geofence.Shapes)

            let inGeofence = false
            if(paths){
                paths.forEach(path => {
                    if(this.findPoint(point, path)){
                        inGeofence |= true
                    }
                })
            }

            let alertEntry = false
            let alertLeave = false
            let alertSpeed = false

            let geoState = this.findGeostate(deviceID, geofence.ID)
            if (geoState == null) {
                geoState = new GeoState(deviceID, geofence.ID)
                this.geostates.push(geoState)
            }
            geoState.dt = new Date().getTime() // location.Datetime;

            //alert('geoState entryState=' + geoState.entryState + '; speedState=' +geoState.speedState)
            //alert('geoState speedState=' + geoState.entryState + '; speedState=' +geoState.speedState)

            switch (geoState.entryState){
                case GEOSTATE_NONE:
                case GEOSTATE_ZONE_LEAVE:
                    if (inGeofence) { 
                        alertEntry = true
                        geoState.entryState = GEOSTATE_ZONE_ENTER
                    }
                    break;
                case GEOSTATE_ZONE_ENTER:
                    if(!inGeofence) { 
                        alertLeave = true
                        geoState.entryState = GEOSTATE_ZONE_LEAVE 
                    }
                    break;
            }
            //let speed = Settings.getSpeedIn(location.Speed);
            
            
            let speed = point.Speed
            switch (geoState.speedState){
                case GEOSTATE_NONE:
                case GEOSTATE_SPEED_OK:

                    let speedFrom = getSpeedInMs(geofence.SpeedFrom)
                    let speedTo = getSpeedInMs(geofence.SpeedTo)

                    if (inGeofence && (speed >= speedFrom && speed <= speedTo)) {
                         alertSpeed = true
                         geoState.speedState = GEOSTATE_SPEED_OK
                    }
                    break

                case GEOSTATE_SPEED_OUT:
                    if (!inGeofence || speed < speedFrom || speed > speedTo) { 
                        geoState.speedState = GEOSTATE_SPEED_OK
                    }
                    break
            }

            //alert('geoState finish alertEntry='+ alertEntry +' alertLeave='+alertLeave+ ' alertSpeed = '+alertSpeed)

            //console.log('geoState update')
            //console.log(geoState)
            //console.log(geofence)
            
            if (alertEntry) this.doAlert(ALERT_TYPES.ENTRY, geofence, point)//DoAlert(AlertType.ENTRY, Name, location);
            if (alertLeave) this.doAlert(ALERT_TYPES.LEAVE, geofence, point)//DoAlert(AlertType.LEAVE, Name, location);
            if (alertSpeed) this.doAlert(ALERT_TYPES.SPEED, geofence, point)//DoAlert(AlertType.SPEED, Name, location);

        })
    }

            //if (alertEntry) DoAlert(AlertType.ENTRY, Name, location);
            //if (alertLeave) DoAlert(AlertType.LEAVE, Name, location);
            //if (alertSpeed) DoAlert(AlertType.SPEED, Name, location);
        

    doAlert(atype, geofence, location){
        //alert('doAlert')
        console.log('doAlert')
        console.log(atype)
        console.log('geofence')
        console.log(geofence)
        //console.log(location)

        //Users to Track
        let userGUID = location.UserID ? base64toGuid(location.UserID) : null
        let userInList = geofence.SelectedUserIds.includes(userGUID)
        if( !(geofence.SelectedUserIds=="") && (!userInList) ){
            //alert('exit')
            return false
        }

        let networks = this.onAction({type:'GET_NETWORKS'})
        //console.log(networks)

        let device = null
        let networkID = null 
        networks.forEach(network => {

            if(device) return

            device = getObjectByID(location.ID, network.devices )
            networkID = network.ID
            
        })

        //if(device) alert('device: ' + device.ID + '; ' + device.UserName )

        if(!device) return

        //console.log('device')
        //console.log(device)


        //alert('doAlert '+ atype + '; ' + geofence.Name +  '; ' + location.ID)
        //console.log('doAlert '+ atype + '; ' + geofence.Name +  '; ' + location.ID)
        //console.log('geofence')
        //console.log(geofence)

        //let ENTRY_MESSAGE = 'Entry to "{GEOFENCE}"'
        //let LEAVE_MESSAGE = 'Leave from "{GEOFENCE}"'
        //let SPEED_MESSAGE = 'Speed out of range "{GEOFENCE}" ({SPEED}{SPEED_IN})'

        //ENTRY_MESSAGE = ENTRY_MESSAGE.replace('{GEOFENCE}', geofence.Name)
        //LEAVE_MESSAGE = LEAVE_MESSAGE.replace('{GEOFENCE}', geofence.Name)
        //SPEED_MESSAGE = SPEED_MESSAGE.replace('{GEOFENCE}', geofence.Name)

        switch(atype){

            case ALERT_TYPES.ENTRY:

                let ENTRY_MESSAGE 
                ENTRY_MESSAGE = this.t('GEOFENCE_ENTRY_MESSAGE')
                if(ENTRY_MESSAGE==='GEOFENCE_ENTRY_MESSAGE') ENTRY_MESSAGE = 'Entry to "{GEOFENCE}"'

                ENTRY_MESSAGE = ENTRY_MESSAGE.replace('{GEOFENCE}', geofence.Name)

                if (geofence.EntryActions.AlertDispatcher){
                    //alert('AlertDispatcher ENTRY')

                    let fleetAlert = {
                        type: atype,
                        state: 0,
                        datetime: new Date().getTime(),
                        fromID: device.ID,
                        fromName: device.UserName,
                        content: ENTRY_MESSAGE
                    }

                    console.log(fleetAlert)
                    //alert('fleetAlert! ENTRY')

                    this.onAction({
                        type: 'ADD_ALERT', 
                        fleetAlert: fleetAlert, 
                        networkID: networkID
                    })
                    /**
                     * FleetAlert fa = new FleetAlert();
                            fa.type = (int)atype;
                            fa.state = (int)AlertState.ALERT_INITIATED;
                            fa.date = location.Datetime.ToLocalTime();
                            fa.dispatcherID = ConsoleManager.singleServer.DispatcherID;
                            fa.dispatcherName = ConsoleManager.singleServer.login;
                            fa.fromid = location.DeviceID;
                            fa.fromName = location.FromName;
                            fa.content = String.Format(Properties.Resources.SPEED_MESSAGE, Settings.getSpeedIn(location.Speed) + " " + Settings.getSpeedInStr(), geoname);
                            LocalData.AddAlert(fa);
                            ConsoleManager.MainWindow.alerts?.AddAlert(fa);
                     */
                }

                if (geofence.EntryActions.SendMessageToInitatior){
                    //console.log(geofence)
                    let message = ENTRY_MESSAGE + " - " + geofence.EntryActions.MessageToInitatior
                    //alert('todo SendMessageToInitatior ' + message)
                    this.sendMessage(device.ID, 0, message, networks)
                }


                if(geofence.EntryActions.SendMessage && geofence.EntryActions.MessageObjectId){

                    let id = geofence.EntryActions.MessageObjectId
                    let type = geofence.EntryActions.MessageObjectType
                    
                    let message = ENTRY_MESSAGE + " - " + geofence.EntryActions.Message

                    //alert('SendMessage to ' + id + '; ' + type + '; ' + message)
                    this.sendMessage(id, type, message, networks)

                }

                if (geofence.AddToDynGroup && geofence.DynGroupId){

                    //alert('AddToDynGroup geofence.DynGroupId ' + geofence.DynGroupId)

                    let group = null
                    let networkID = null
                    networks.forEach(network => {

                        if(group) return

                        networkID = network.ID
                        group = getObjectByID(geofence.DynGroupId, network.groups, 'GUID' )
                        
                    })
                    //console.log(group)
                    //alert('find group in network '+ networkID)

                    let userID = device.userID
                    let name

                    if(group){
                        this.onAction({
                            type: 'DYNAMIC_GROUP_PROPERTIES_GET',
                            networkID: networkID, 
                            groupID: group.ID, 
                            groupGUID: group.GUID,
                            onComplete: (dynGroup)=>{
                                console.log('Get dynGroup')
                                console.log(dynGroup)

                                let userGUID = base64toGuid(device.UserID)
                                let index = getIndexByID(userGUID, dynGroup.Users)
                                if(index==null){
                                    console.log('dynGroup.Users.push '+userGUID)
                                    dynGroup.Users.push({
                                        ID: userGUID,
                                        Name: device.UserName
                                    })
                                }

                                dynGroup.Users = dynGroup.Users.map((user)=>(user.ID))
                                console.log('dynGroup updated')
                                console.log(dynGroup)

                                this.onAction({
                                    type: 'DYNAMIC_GROUP_UPDATE',
                                    group: dynGroup,
                                    networkID: networkID
                                })

                                //alert('append user onComplete DYNAMIC_GROUP_PROPERTIES_GET')
                            }
                        })
                        
                    }

                    // 

                    //if (Guid.TryParse(DynGroupId, out grpid))
                    //{
                    //    ConsoleManager.SendDynGroupUserOperation(network.ObjectId, grpid, (obj as GuiDevice).UserID, DataOpType.ADD, false);
                    //}
                }



                break

            case ALERT_TYPES.LEAVE:

                let LEAVE_MESSAGE 
                LEAVE_MESSAGE = this.t('GEOFENCE_LEAVE_MESSAGE')
                if(LEAVE_MESSAGE==='GEOFENCE_LEAVE_MESSAGE') LEAVE_MESSAGE = 'Leave from "{GEOFENCE}"'

                LEAVE_MESSAGE = LEAVE_MESSAGE.replace('{GEOFENCE}', geofence.Name)

                if (geofence.LeaveActions.AlertDispatcher){
                    //alert('AlertDispatcher LEAVE')

                    let fleetAlert = {
                        type: atype,
                        state: 0,
                        datetime: new Date().getTime(),
                        fromID: device.ID,
                        fromName: device.UserName,
                        content: LEAVE_MESSAGE
                    }

                    console.log(fleetAlert)
                    //alert('fleetAlert! LEAVE')

                    this.onAction({
                        type: 'ADD_ALERT', 
                        fleetAlert: fleetAlert,
                        networkID: networkID
                    })

                }


                if (geofence.LeaveActions.SendMessageToInitatior){
                    console.log(geofence)
                    let message = LEAVE_MESSAGE + " - " + geofence.LeaveActions.MessageToInitatior
                    //alert('todo SendMessageToInitatior ' + message)
                    this.sendMessage(device.ID, 0, message, networks)
                }


                if(geofence.LeaveActions.SendMessage && geofence.LeaveActions.MessageObjectId){

                    let id = geofence.LeaveActions.MessageObjectId
                    let type = geofence.LeaveActions.MessageObjectType
                    
                    let message = LEAVE_MESSAGE + " - " + geofence.LeaveActions.Message

                    //alert('todo SendMessage ' + type + ' ' + message)
                    this.sendMessage(id, type, message, networks)

                }


                if (geofence.DeleteFromDynGroup && geofence.DynGroupId){

                    //alert ('DeleteFromDynGroup geofence.DynGroupId ' + geofence.DynGroupId)

                    let group = null
                    let networkID = null
                    networks.forEach(network => {

                        if(group) return

                        networkID = network.ID
                        group = getObjectByID(geofence.DynGroupId, network.groups, 'GUID' )
                        
                    })
                    //console.log(group)
                    //alert('find group in network '+ networkID)

                    let userID = device.userID
                    let name

                    if(group){
                        this.onAction({
                            type: 'DYNAMIC_GROUP_PROPERTIES_GET',
                            networkID: networkID, 
                            groupID: group.ID, 
                            groupGUID: group.GUID,
                            onComplete: (dynGroup)=>{
                                console.log('Get dynGroup')
                                console.log(dynGroup)

                                let userGUID = base64toGuid(device.UserID)
                                let index = getIndexByID(userGUID, dynGroup.Users)
                                if(index!==null){
                                    console.log('dynGroup.Users.delete '+userGUID)
                                    dynGroup.Users.splice(index, 1)
                                }

                                dynGroup.Users = dynGroup.Users.map((user)=>(user.ID))
                                console.log('dynGroup updated')
                                console.log(dynGroup)

                                this.onAction({
                                    type: 'DYNAMIC_GROUP_UPDATE',
                                    group: dynGroup,
                                    networkID: networkID
                                })

                                //alert('delete user onComplete DYNAMIC_GROUP_PROPERTIES_GET')
                            }
                        })
                        
                    }

                    // 

                    //if (Guid.TryParse(DynGroupId, out grpid))
                    //{
                    //    ConsoleManager.SendDynGroupUserOperation(network.ObjectId, grpid, (obj as GuiDevice).UserID, DataOpType.ADD, false);
                    //}
                }

                break

            case ALERT_TYPES.SPEED:


                let SPEED_MESSAGE 
                SPEED_MESSAGE = this.t('GEOFENCE_SPEED_MESSAGE')
                if(SPEED_MESSAGE==='GEOFENCE_SPEED_MESSAGE') SPEED_MESSAGE = 'Speed out of range "{GEOFENCE}" ({SPEED})'

                let speed = Number(calcSpeed(location.Speed, getSpeedIn())).toFixed(1) + getSpeedIn()
                SPEED_MESSAGE = SPEED_MESSAGE.replace('{GEOFENCE}', geofence.Name).replace('{SPEED}', speed)

                //console.log(location)
                //alert('SPEED_MESSAGE '+  location.Speed + ' : '  + SPEED_MESSAGE)

                if (geofence.SpeedActions.AlertDispatcher){
                    //alert('AlertDispatcher SPEED')

                    let fleetAlert = {
                        type: atype,
                        state: 0,
                        datetime: new Date().getTime(),
                        fromID: device.ID,
                        fromName: device.UserName,
                        content: SPEED_MESSAGE.replace('%s', geofence.Name)
                    }

                    console.log(fleetAlert)
                    //alert('fleetAlert! SPEED')

                    this.onAction({
                        type: 'ADD_ALERT', 
                        fleetAlert: fleetAlert,
                        networkID: networkID
                    })

                }

                if (geofence.SpeedActions.SendMessageToInitatior){
                    console.log(geofence)
                    let message = SPEED_MESSAGE.replace('%s', geofence.Name) + " - " + geofence.SpeedActions.MessageToInitatior
                    //alert('todo SendMessageToInitatior ' + message)
                    this.sendMessage(device.ID, 0, message, networks)
                }


                if(geofence.SpeedActions.SendMessage && geofence.SpeedActions.MessageObjectId){

                    let id = geofence.SpeedActions.MessageObjectId
                    let type = geofence.SpeedActions.MessageObjectType
                    
                    let message = SPEED_MESSAGE.replace('%s', geofence.Name) + " - " + geofence.SpeedActions.Message

                    //alert('todo SendMessage ' + type + ' ' + message)
                    this.sendMessage(id, type, message, networks)

                }

                break

        }
        
    }

/**
 * @param {*} objectID 
 * @param {*} objectType  5-group 3-user 26-dyngroup
 * @param {*} message 
 * @param {*} networks
 */
    sendMessage(objectID, objectType, message, networks){

        let userID = ''
        let deviceID = ''
        let networkID = '' 
        let groupID = ''
        let targetType = null

        console.log('sendMessage '+message+' message to objectID='+objectID + ' objectType=' + objectType)

        if(objectType==0){

            let device = null
            networks.forEach(network => {

                if(device) return

                device = getObjectByID(objectID, network.devices )
                if(device){

                    //console.log(device)

                    userID = device.UserID
                    deviceID = device.ID
                    networkID = network.ID
                    targetType = 0

                    console.log(device)
                    //alert('find device ' + device.ID)
                }
                
            })

        }

        if(objectType==3){

            let user = null
            networks.forEach(network => {

                if(user) return

                if(!user) user = getObjectByID(objectID, network.users )
                if(!user) user = getObjectByID(objectID, network.users, 'GUID')
                if(user){

                    let toDevice = getObjectByID(user.ID, network.devices, 'UserID')
                    if(toDevice) deviceID = toDevice.ID

                    userID = user.ID
                    //deviceID = device.DeviceID
                    networkID = network.ID
                    targetType = 0

                    console.log(user)
                    alert('find user ' +user.Name)
                }
                
            })

        }

        if(objectType==5 || objectType==26){

            let group = null
            networks.forEach(network => {

                if(group) return

                if(!group) group = getObjectByID(objectID, network.groups )
                if(!group) group = getObjectByID(objectID, network.groups, 'GUID')
                if(group){

                    groupID = group.ID
                    //deviceID = device.DeviceID
                    networkID = network.ID
                    targetType = 1

                    console.log(group)
                    alert('find group ' + group.Name)
                }
                
            })

        }



        if(userID || groupID){
            this.onAction({
                type:'SEND_MESSAGE',
                message: message,
                userID: userID,
                deviceID: deviceID,
                groupID: groupID,
                targetType: targetType,
                networkID: networkID
            })
        }

/*
        case 'SEND_MESSAGE': {
            //console.log('action')
            //console.log(action)
            const { message, userID, deviceID, groupID, targetType, networkID } = action
            this.api.querySendTextMessage(message, userID, deviceID, groupID, targetType, networkID)
         
            break
        }
        */

    }



    findGeostate(deviceID, geofenceID){
        let geostate = null

        let find = this.geostates.filter(geostate => (geostate.deviceID==deviceID && geostate.geofenceID==geofenceID))
        if(find && find.length){
            geostate = find[0]
        }

        return geostate
    }


    getPaths(shapes){
        let paths = []
        if(typeof shapes === 'string'){
            let arr = shapes.split('|')
            for(let i=0; i<arr.length; i++ ){
                let shape = arr[i]
                if(!shape) continue

                shape = String(shape).replaceAll('lng', '"lng"');
                shape = String(shape).replaceAll('lat', '"lat"');

                let path = JSON.parse(shape)
                paths.push(path)
            }
        }else{
            return shapes
        }

        return paths
    }


    findPoint(point, path){
        console.log('findPoint function')
        console.log(point)
        console.log(path)
        let sides = path.length - 1
        let j = sides - 1
        let pointStatus = false
        for (let i = 0; i < sides; i++){
            if (path[i].lng < point.lng && path[j].lng >= point.lng || path[j].lng < point.lng && path[i].lng >= point.lng){
                if (path[i].lat + (point.lng - path[i].lng) / (path[j].lng - path[i].lng) * (path[j].lat - path[i].lat) < point.lat){
                    pointStatus = !pointStatus
                }
            }
            j = i;
        }
        return pointStatus
    }

}

class GeoState{

    constructor(deviceID, geofenceID){

        this.deviceID = deviceID
        this.geofenceID = geofenceID
        this.dt = new Date().getTime()
        this.entryState = GEOSTATE_NONE
        this.speedState = GEOSTATE_NONE
        //this.deviceName = deviceName

    }

}
